var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.fieldEditorType,{tag:"div",attrs:{"options":_vm.fieldOptions,"propReadonly":_vm.readonly,"propSetValueAfterChoose":true,"propValue":_vm.value},on:{"change":_vm.changeHandle,"input":_vm.inputHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }